import { IMenu } from '@ds/ng-wt-layout';
import { CONTENT_ROUTES_PATHS } from '../shared/constants/contents.constants';
 
export const menuData: IMenu[] = [
  {
    name: 'ACCOUNT',
    id: 4,
    iconClassName: '',
    tooltip: 'ACCOUNT',
    routerUrl: CONTENT_ROUTES_PATHS.PLAYER_INFORMATION + '/' + CONTENT_ROUTES_PATHS.PLAYER_PROFILE,
    children: [
      {
        name: 'PLAYER_INFORMATION',
        id: 5,
        iconClassName: '',
        tooltip: 'PLAYER_INFORMATION',
        routerUrl: '/' + CONTENT_ROUTES_PATHS.PLAYER_INFORMATION
      },
      {
        name: 'ACCOUNT_SECURITY',
        id: 6,
        iconClassName: '',
        tooltip: 'ACCOUNT_SECURITY',
        routerUrl: '/' + CONTENT_ROUTES_PATHS.ACCOUNT_SECURITY
      },
      {
        name: 'WIN_LOSS_STATEMENT',
        id: 7,
        iconClassName: '',
        tooltip: 'WIN_LOSS_STATEMENT',
        routerUrl: '/' + CONTENT_ROUTES_PATHS.WIN_LOSS_STATEMENT
      },
      {
        name: 'LOGOUT',
        id: 8,
        iconClassName: '',
        tooltip: 'LOGOUT',
        routerUrl: ''
      }
    ]
  },
];